import type { RouteRecordNameGeneric } from 'vue-router'

import { routeAutoRepeatDetail } from '@/routers/routes/mainRoutes/routeAccountings/autoRepeatsRoutes.ts'
import { routeDunningDetail } from '@/routers/routes/mainRoutes/routeAccountings/dunningRoutes.ts'
import { routeEInvoiceImportDetail } from '@/routers/routes/mainRoutes/routeAccountings/eInvoiceImportsRoutes.ts'
import { routePaymentEntryDetail } from '@/routers/routes/mainRoutes/routeAccountings/paymentEntriesRoutes.ts'
import { routePurchaseInvoiceDetail } from '@/routers/routes/mainRoutes/routeAccountings/puchaseInvoiceRoutes.ts'
import { routeSalesInvoiceDetail } from '@/routers/routes/mainRoutes/routeAccountings/salesInvoiceRoutes.ts'
import { routeInboxDetail } from '@/routers/routes/mainRoutes/routeActivities/communicationRoutes'
import { routeTodoDetail } from '@/routers/routes/mainRoutes/routeActivities/todoRoutes.ts'
import { routePurchaseOrderDetail } from '@/routers/routes/mainRoutes/routeBuying/purchaseOrderRoutes'
import { routeRequestForQuotationDetail } from '@/routers/routes/mainRoutes/routeBuying/requestForQuotationRoutes'
import { routeSupplierQuotationDetail } from '@/routers/routes/mainRoutes/routeBuying/supplierQuotationRoutes'
import { routeFileDetail } from '@/routers/routes/mainRoutes/routeFileSystem/filesRoutes.ts'
import { routeEmployeeDetail } from '@/routers/routes/mainRoutes/routeHR/employeeRoutes.ts'
import { routeMarketingCampaignDetail } from '@/routers/routes/mainRoutes/routeMarketing/marketingCampaignRoutes'
import { routeDistributionListDetail } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/distributionListRoutes'
import { routeNewsletterArticleDetail } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/newsletterArticleRoutes'
import { routeSubscriberDetail } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/subscriberRoutes'
import { routeDeliveryNoteDetail } from '@/routers/routes/mainRoutes/routeProjects/deliveryNoteRoutes.ts'
import { routeProjectDetail } from '@/routers/routes/mainRoutes/routeProjects/projectRoutes.ts'
import { routeTaskDetail } from '@/routers/routes/mainRoutes/routeProjects/taskRoutes.ts'
import { routeTimesheetDetail } from '@/routers/routes/mainRoutes/routeProjects/timesheetRoutes.ts'
import { routePersonDetail } from '@/routers/routes/mainRoutes/routeRelationships/personsRoutes.ts'
import { routeCustomerDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/customer'
import { routeInvestorDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/investor'
import { routeOtherDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/other'
import { routePartnerDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/partner'
import { routeSalesPartnerDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/salesPartner'
import { routeSupplierDetail } from '@/routers/routes/mainRoutes/routeRelationships/routeOrganizationDetail/supplier'
import { routeDealDetail } from '@/routers/routes/mainRoutes/routeSales/dealsRoutes.ts'
import { routeQuotationDetail } from '@/routers/routes/mainRoutes/routeSales/quotationsRoutes.ts'
import { routeSalesOrderDetail } from '@/routers/routes/mainRoutes/routeSales/salesOrdersRoutes.ts'
import { routeActivityTypeDetail } from '@/routers/routes/mainRoutes/routeServices/activityTypesRoutes.ts'
import { routeItemGroupDetail } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemGroupsRoutes.ts'
import { routeItemDetail } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemsRoutes.ts'
import { routeSerialNoDetail } from '@/routers/routes/mainRoutes/routeServices/routeItems/serialNoRoutes'
import { routeItemPriceDetail } from '@/routers/routes/mainRoutes/routeServices/routePrices/itemPricesRoutes.ts'
import { routePriceListDetail } from '@/routers/routes/mainRoutes/routeServices/routePrices/priceListRoutes.ts'
import { routePricingRuleDetail } from '@/routers/routes/mainRoutes/routeServices/routePrices/pricingRuleRoutes.ts'
import { routeUOMDetail } from '@/routers/routes/mainRoutes/routeServices/uomRoutes.ts'
import { routeCurrencySettingsDetail } from '@/routers/routes/mainRoutes/routeSettings/currencyRoutes'
import { routeDataImportDetail } from '@/routers/routes/mainRoutes/routeSettings/dataImportRoutes.ts'
import { routeLetterheadDetail } from '@/routers/routes/mainRoutes/routeSettings/letterheadRoutes.ts'
import { routePrintDesignerHome } from '@/routers/routes/mainRoutes/routeSettings/printDesignerRoutes.ts'
import { routePrintFormatDetail } from '@/routers/routes/mainRoutes/routeSettings/printFormatRoutes.ts'
import { routeAccountDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/accountsRoutes.ts'
import { routeCostCenterDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/costCenterRoutes.ts'
import { routeDatevSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/datevSettingsRoutes.ts'
import { routeDunningPlanDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningPlanRoutes.ts'
import { routeDunningTypeDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningTypesRoutes.ts'
import { routeManagementReportRowDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportRowRoutes.ts'
import { routeManagementReportSummaryRowDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportSummaryRowRoutes.ts'
import { routePaymentTermDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsRoutes.ts'
import { routePaymentTermsTemplateDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsTemplatesRoutes.ts'
import { routeVatReturnRowDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/vatReturnRowRoutes.ts'
import { routeNotificationDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/notificationRoutes.ts'
import { routeSlackDetail } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/slackRoutes.ts'
import { routeCustomerGroupDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/customerGroupRoutes'
import { routeTWPhoneTypeDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/phoneTypeRoutes.ts'
import { routeTWRatingDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/ratingRoutes.ts'
import { routeRoleDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/roleRoutes.ts'
import { routeSalutationDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/salutationRoutes'
import { routeSupplierGroupDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/supplierGroupRoutes'
import { routeWeblinkTypeDetail } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/weblinkTypeRoutes.ts'
import { routeConnectedAppDetail } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/connectedAppRoutes'
import { routeEmailAccountDetail } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailAccountRoutes'
import { routeEmailConfigurationHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailConfigurationRoutes.ts'
import { routeEmailDomainDetail } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailDomainRoutes'
import { routeEmailTemplateDetail } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailTemplateRoutes'
import { routeTokenCacheDetail } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/tokenCacheRoutes'
import { routeGoogleCalendarDetail } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleCalendarRoutes.ts'
import { routeGoogleSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleSettingsRoutes.ts'
import { routeWebhookDetail } from '@/routers/routes/mainRoutes/routeSettings/routeInterfaces/webhookRoutes.ts'
import { routeBuyingCenterRoleDetail } from '@/routers/routes/mainRoutes/routeSettings/routeSales/buyingCenterRoleRoutes'
import { routeQuotationLostReasonDetail } from '@/routers/routes/mainRoutes/routeSettings/routeSales/quotationLostReasonRoutes'
import { routeSystemSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/systemSettingsRoutes.ts'
import { routeTagDetail } from '@/routers/routes/mainRoutes/routeSettings/tagsRoutes.ts'
import { routeTermsAndConditionsSettingsDetail } from '@/routers/routes/mainRoutes/routeSettings/termsAndConditionsSettingRoutes'
import { routeUserDetail } from '@/routers/routes/mainRoutes/routeSettings/usersRoutes.ts'
import { routePurchaseReceiptDetail } from '@/routers/routes/mainRoutes/routeStock/purchaseReceiptsRoutes'
import { routeStockEntryDetail } from '@/routers/routes/mainRoutes/routeStock/stockEntriesRoutes'
import { routeWarehouseDetail } from '@/routers/routes/mainRoutes/routeStock/warehousesRoutes'

const routeMap: Record<string, RouteRecordNameGeneric> = {
  account: routeAccountDetail.name,
  'activity-type': routeActivityTypeDetail.name,
  'auto-repeat': routeAutoRepeatDetail.name,
  bank: routeInvestorDetail.name,
  communication: routeInboxDetail.name,
  'connected-app': routeConnectedAppDetail.name,
  contact: routePersonDetail.name,
  'cost-center': routeCostCenterDetail.name,
  currency: routeCurrencySettingsDetail.name,
  customer: routeCustomerDetail.name,
  'customer-group': routeCustomerGroupDetail.name,
  'data-import': routeDataImportDetail.name,
  'datev-unternehmen-online-settings': routeDatevSettingsHome.name,
  'delivery-note': routeDeliveryNoteDetail.name,
  dunning: routeDunningDetail.name,
  'dunning-plan': routeDunningPlanDetail.name,
  'dunning-type': routeDunningTypeDetail.name,
  'e-invoice-import': routeEInvoiceImportDetail.name,
  'email-account': routeEmailAccountDetail.name,
  'email-domain': routeEmailDomainDetail.name,
  'email-group': routeDistributionListDetail.name,
  'email-group-member': routeSubscriberDetail.name,
  'email-template': routeEmailTemplateDetail.name,
  employee: routeEmployeeDetail.name,
  file: routeFileDetail.name,
  'google-calendar': routeGoogleCalendarDetail.name,
  'google-settings': routeGoogleSettingsHome.name,
  item: routeItemDetail.name,
  'item-group': routeItemGroupDetail.name,
  'item-price': routeItemPriceDetail.name,
  'letter-head': routeLetterheadDetail.name,
  'marketing-campaign': routeMarketingCampaignDetail.name,
  newsletter: routeNewsletterArticleDetail.name,
  notification: routeNotificationDetail.name,
  opportunity: routeDealDetail.name,
  'payment-entry': routePaymentEntryDetail.name,
  'payment-term': routePaymentTermDetail.name,
  'payment-terms-template': routePaymentTermsTemplateDetail.name,
  'price-list': routePriceListDetail.name,
  'pricing-rule': routePricingRuleDetail.name,
  'print-designer': routePrintDesignerHome.name,
  'print-format': routePrintFormatDetail.name,
  project: routeProjectDetail.name,
  'purchase-invoice': routePurchaseInvoiceDetail.name,
  'purchase-order': routePurchaseOrderDetail.name,
  'purchase-receipt': routePurchaseReceiptDetail.name,
  quotation: routeQuotationDetail.name,
  'quotation-lost-reason': routeQuotationLostReasonDetail.name,
  'request-for-quotation': routeRequestForQuotationDetail.name,
  'sales-invoice': routeSalesInvoiceDetail.name,
  'sales-order': routeSalesOrderDetail.name,
  'sales-partner': routeSalesPartnerDetail.name,
  salutation: routeSalutationDetail.name,
  'serial-no': routeSerialNoDetail.name,
  'slack-webhook-url': routeSlackDetail.name,
  'stock-entry': routeStockEntryDetail.name,
  supplier: routeSupplierDetail.name,
  'supplier-group': routeSupplierGroupDetail.name,
  'supplier-quotation': routeSupplierQuotationDetail.name,
  'system-settings': routeSystemSettingsHome.name,
  tag: routeTagDetail.name,
  task: routeTaskDetail.name,
  'terms-and-conditions': routeTermsAndConditionsSettingsDetail.name,
  timesheet: routeTimesheetDetail.name,
  todo: routeTodoDetail.name,
  'token-cache': routeTokenCacheDetail.name,
  'tw-buying-center-role': routeBuyingCenterRoleDetail.name,
  'tw-email-config': routeEmailConfigurationHome.name,
  'tw-management-report-row': routeManagementReportRowDetail.name,
  'tw-management-report-summary-row': routeManagementReportSummaryRowDetail.name,
  'tw-other': routeOtherDetail.name,
  'tw-partner': routePartnerDetail.name,
  'tw-person': routePersonDetail.name,
  'tw-phone-type': routeTWPhoneTypeDetail.name,
  'tw-rating': routeTWRatingDetail.name,
  'tw-role': routeRoleDetail.name,
  'tw-vat-return-row': routeVatReturnRowDetail.name,
  'tw-weblink-type': routeWeblinkTypeDetail.name,
  uom: routeUOMDetail.name,
  user: routeUserDetail.name,
  warehouse: routeWarehouseDetail.name,
  webhook: routeWebhookDetail.name,
}

export { routeMap }
